<script>
import VueChartJs from 'vue-chartjs'

export default {
  name: 'PieChart',
  extends: VueChartJs.Pie,
  mixins: [VueChartJs.mixins.reactiveProp],
  data () {
    return {}
  },
  props: {
    chartData: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    }
  },
  watch: {
    options: {
      handler (val) {
        // Handle reactivity on options values
        this.$data._chart.destroy()
        this.renderChart(this.chartData, this.options)
      },
      deep: true
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/PieChart.vue